import React from 'react'
import { Box, Card, Grid, Link, Typography, useMediaQuery, Button } from '@material-ui/core'
import { connect } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import { Link as RouterLink } from 'react-router-dom'
import {
  selectCurrentLocationWithAddress,
  selectCurrentSavedLocation,
} from '../../redux/modules/selectors'
import { savedLocationsRoute } from '../../routes/routes'
import { themeConWeb } from './../../util/modernThemeConweb'

const useStyles = makeStyles(theme => ({
  addressBox: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(3),
  },
  addressLine: {
    fontSize: `12px`,
    margin: '2px 0',
  },
  firstAddressLine: {
    fontSize: `14px`,
    fontWeight: 400,
  },
  changeSavedLocation: {
    cursor: 'pointer',
    fontSize: `${themeConWeb.fontSizes.base}`,
    margin: '6px 0',
    '&:hover': {
      textDecoration: `underline ${themeConWeb.color.two}`,
    },
  },
  [theme.breakpoints.up('sm')]: {
    addressBox: {
      alignItems: 'center',
      flexDirection: 'row',
      padding: '20px',
    },
    firstAddressLine: {
      fontSize: `14px`,
      fontWeight: 400,
    },
    changeSavedLocation: {
      fontSize: `${themeConWeb.fontSizes.base}`,
      margin: '12px auto',
    },
  },
  [theme.breakpoints.up('md')]: {
    addressBox: {
      alignItems: 'flex-start',
      flexDirection: 'column',
    },
    changeSavedLocation: {
      fontSize: `${themeConWeb.fontSizes.base}`,
      margin: '12px 0',
    },
  },
}))

export const fillAddressLines = address => {
  let { name, deliveryLocationName, street, city, state, zip } = address
  return [name || deliveryLocationName, street, `${city}, ${state} ${zip}`].filter(Boolean)
}

const HomeLocationWidget = ({ location, currentSavedLocation }) => {
  const classes = useStyles()
  const mobileView = useMediaQuery(theme => theme.breakpoints.between('xs', 'sm'))
  if (mobileView) {
    return (
      <MobileHomeLocationWidget location={location} currentSavedLocation={currentSavedLocation} />
    )
  }

  return (
    <Grid container data-testid="HomeLocationWidget">
      <Grid item>
        <Typography color="textSecondary" style={{ fontWeight: 800 }}>
          Location
        </Typography>
        <Box>
          {location &&
            fillAddressLines(currentSavedLocation || location).map((line, i) => {
              return (
                <>
                  <Typography
                    key={`${line}-${i}`}
                    className={cn(classes.addressLine, { [classes.firstAddressLine]: i === 0 })}
                  >
                    {line}
                  </Typography>
                </>
              )
            })}
        </Box>
        <Typography className={classes.changeSavedLocation} color={themeConWeb.color.two}>
          <Link href={savedLocationsRoute.path}>Change</Link>
        </Typography>
      </Grid>
    </Grid>
  )
}

const MobileHomeLocationWidget = ({ location, currentSavedLocation }) => (
  <Card>
    <Grid container spacing={1} style={{ display: 'flex', justifyContent: 'center' }}>
      <Grid item>
        <Typography style={{ color: 'gray' }}>Location</Typography>
      </Grid>
      <Grid item>
        <Typography>
          {currentSavedLocation?.deliveryLocationName || location.deliveryLocationName}
        </Typography>
      </Grid>
    </Grid>
    <Box display={'flex'} justifyContent={'center'} mt={3}>
      <Button variant={'outlined'} component={RouterLink} to={savedLocationsRoute.path}>
        Change
      </Button>
    </Box>
  </Card>
)

const mapStateToProps = state => {
  const location = selectCurrentLocationWithAddress(state)
  const currentSavedLocation = selectCurrentSavedLocation(state)

  return {
    currentSavedLocation,
    location,
  }
}

export default connect(mapStateToProps)(HomeLocationWidget)
